import { AxiosResponse } from 'axios'

export const getFilename = (response: AxiosResponse): string | undefined =>
    response.headers['content-disposition']?.split('filename=')[1]
